// Le libellé d'un pays tel qu'il s'affiche sur la carte : son nom, puis son
// identifiant entre parenthèses.
//
// L'identifiant est ce que tout le reste de l'écosystème emploie — les
// commandes des bots, les URL du dashboard, les échanges avec le staff — mais
// la carte ne l'affichait nulle part. Il fallait donc le retrouver ailleurs
// pour agir sur ce qu'on venait de voir.
//
// Centralisé ici parce que le nom apparaît à sept endroits (fiche de région,
// recherche, palette, légende, barre du haut…) : sans point unique, la
// parenthèse serait posée sur cinq d'entre eux et manquerait aux deux autres,
// sans que personne ne s'en aperçoive.

/**
 * @param {string} name  Nom du pays. Vide ou absent ⇒ chaîne vide.
 * @param {number|string} id  Identifiant. Absent ⇒ le nom seul.
 * @returns {string}
 */
export function countryLabel(name, id) {
  const label = (name ?? '').toString().trim()
  if (!label) return ''
  // `0` est un identifiant valide côté base : ne pas le confondre avec absent.
  if (id === null || id === undefined || id === '') return label
  return `${label} (${id})`
}

/** Variante pour les objets qui portent déjà les deux champs. */
export const countryLabelOf = (o) => countryLabel(o?.country_name, o?.country_id)
